import { useEffect, useState } from 'react'
import { Body } from '../../Layouts/Body'
import { WhiteContainer } from '../../../components/WhiteContainer'
import { iPerguntasFrequentes } from '../../../interfaces'
import { ModalTopico } from './Components/ModalTopico'
import { TextBox } from './Components/TextBox'
import { TextBoxAdd } from './Components/TextBoxAdd'
import { Main } from './styles'
import { appApi } from '../../../services/appApi'
import { Flex } from '@chakra-ui/react'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { useNavigate } from 'react-router-dom'

export const PerguntasFrequentesRh: React.FC = () => {
  const nav = useNavigate()
  const [ModalIsOPen, setModalIsIOpen] = useState(false)
  const [Pergunta, setPergunta] = useState<iPerguntasFrequentes>()
  const [Perguntas, setPerguntas] = useState<iPerguntasFrequentes[]>([])

  function onRequestClose(): void {
    setModalIsIOpen(false)
    setPergunta(undefined)
  }

  function onRequestOpen(pergunta: iPerguntasFrequentes): void {
    setPergunta(pergunta)
    setModalIsIOpen(true)
  }

  function obterPerguntas(): void {
    appApi.get('PerguntasFrequentes').then(res => setPerguntas(res.data)).catch(err => console.log(err))
  }

  function CriarPergunta(titulo: string, descricao: string): void {
    const form = {
      Titulo: titulo,
      Descricao: descricao
    }

    appApi.post('PerguntasFrequentes', form)
      .then(() => {
        onRequestClose()
        obterPerguntas()
      })
      .catch(err => console.log(err))
  }

  function AtualizarPergunta(titulo: string, descricao: string): void {
    const form = {
      titulo: titulo,
      descricao: descricao
    }
    appApi.put(`PerguntasFrequentes/${Pergunta?.id ?? ''}`, form)
      .then(() => {
        onRequestClose()
        obterPerguntas()
      })
      .catch(err => console.log(err))
  }

  function DeletarPergunta(): void {
    appApi.delete(`PerguntasFrequentes/${Pergunta?.id ?? ''}`)
      .then(() => {
        onRequestClose()
        obterPerguntas()
      }).catch(err => console.log(err))
  }

  useEffect(() => {
    obterPerguntas()
  }, [])

  return (
    <Body>
      {
        (ModalIsOPen) && (
          <ModalTopico
            onRequestClose={onRequestClose}
            Create={CriarPergunta}
            Delete={DeletarPergunta}
            Update={AtualizarPergunta}
            isOpen={ModalIsOPen}
            pergunta={Pergunta}
          />
        )
      }
      <Flex justifyContent={'space-between'} gap={'2rem'} alignItems='center' mb={'1.5rem'}>
        <h2>Configure e personalize as perguntas mais frequentes dentro de sua organização</h2>
        <ButtonCmp VarColor='c6' onClick={() => nav(-1)}>Voltar</ButtonCmp>
      </Flex>
      <WhiteContainer>
        <Main>
          <img src='https://sigah.blob.core.windows.net/onboard/93e163ff-dc29-4ffb-9c95-cd44d3a2d68d.png' />
          <section>
            <h2>Perguntas frequentes</h2>
            <Flex direction={'column'} overflowY={'auto'} maxHeight={'26rem'} mt={'1rem'} pr={'0.5rem'}>
              {
                Perguntas.map((e: iPerguntasFrequentes, i) => {
                  return (
                    <TextBox
                      key={i}
                      pergunta={e}
                      isFirst={i === 0}
                      openModal={onRequestOpen}
                    />
                  )
                })
              }
              <TextBoxAdd
                onClick={() => setModalIsIOpen(true)}
              />
            </Flex>
          </section>
        </Main>
      </WhiteContainer>
    </Body>
  )
}
